import { Switch, Route, Router as WouterRouter } from "wouter";
import { useLocation } from "wouter";
import { lazy, Suspense, useEffect } from "react";
import { SiteConfigProvider } from "@/context/SiteConfigContext";
import { applySeo } from "@/lib/seo";
import Home from "@/pages/home";
const NotFound = lazy(() => import("@/pages/not-found"));
const Services = lazy(() => import("@/pages/services"));
const About = lazy(() => import("@/pages/about"));
const Book = lazy(() => import("@/pages/book"));
const Contact = lazy(() => import("@/pages/contact"));
const Privacy = lazy(() => import("@/pages/privacy"));
const Warranty = lazy(() => import("@/pages/warranty"));

/**
 * Compute the Wouter router base path safely.
 *
 * import.meta.env.BASE_URL is handled safely:
 *   "./"  → ""  (relative build, deploy at root)
 *   "."   → ""  (degenerate case from replace, never blank the page)
 *   "/"   → ""  (absolute root — used for swiftmobilemechanics.com)
 */
const routerBase = (() => {
  const explicit = import.meta.env.VITE_APP_BASE as string | undefined;
  if (explicit) {
    return explicit.replace(/\/$/, "");
  }
  const b = import.meta.env.BASE_URL ?? "";
  if (!b || b === "/" || b === "./" || b === ".") return "";
  return b.replace(/\/$/, "");
})();

function Router() {
  const [location] = useLocation();
  const normalizedLocation = location.length > 1 ? location.replace(/\/+$/, "") : location;

  useEffect(() => {
    const persistentHero = document.getElementById("persistent-home-hero");
    if (persistentHero) {
      persistentHero.hidden = normalizedLocation !== "/";
    }
    applySeo(normalizedLocation);
  }, [normalizedLocation]);

  return (
    <Suspense fallback={null}>
      <Switch>
        <Route path="/" component={Home} />
        <Route path="/services" component={Services} />
        <Route path="/about" component={About} />
        <Route path="/book" component={Book} />
        <Route path="/contact" component={Contact} />
        <Route path="/privacy" component={Privacy} />
        <Route path="/warranty" component={Warranty} />
        <Route component={NotFound} />
      </Switch>
    </Suspense>
  );
}

function App() {
  return (
    <SiteConfigProvider>
      <WouterRouter base={routerBase}>
        <Router />
      </WouterRouter>
    </SiteConfigProvider>
  );
}

export default App;
